import ValidationInterface from '@/plans/common/validation-interface';
import { SDKCategories } from '@/common/persist-cart/categories';

export default class extends ValidationInterface {
  async requires() {
    return [this.current("videosdk_cmr_1TB").require(SDKCategories, { billingCycleMatch: false })];
  }

  async conflicts() {
    return this.current(["videosdk_cmr_1TB"]).conflict(["videosdk_cmr_1TB"]);
  }
}
